export const rulesOptions = [
  { value: "all", label: "All Invoices" },
  { value: "ob", label: "Online Booking" },
  { value: "in_clinic", label: "In Clinic" },
];

export const applicationLevelOptions = [
  { value: "invoice", label: "Invoice Level" },
  { value: "item", label: "Item Level" },
];

export const taxTypeOptions = [
  { value: "surcharge", label: "Surcharge" },
  { value: "pre_tax", label: "Pre-Tax" },
  { value: "post_tax", label: "Post-Tax" },
];

export const exclusionsOptions = [
  { value: "memberships", label: "Memberships" },
  { value: "gift_card", label: "Gift Card" },
  { value: "cancellation_fee_clinic", label: "Cancellation Fee" },
  { value: "treatment_plan", label: "Treatment Plan" },
  { value: "service_deposits", label: "Service Deposits" },
];

export const cascadingOptions = [
  { value: false, label: "No" },
  { value: true, label: "Yes" },
];

export const getInitialValues = (modal) => {
  const data = modal.data || {};

  const applicationLevel =
    applicationLevelOptions.find((option) => option.value === data.level) ||
    applicationLevelOptions[0];

  const taxType =
    taxTypeOptions.find((option) => option.value === data.tax_type) ||
    taxTypeOptions[0];

  const rules =
    rulesOptions.find((option) => option.value === data.type) ||
    rulesOptions[0];

  const exclusions = exclusionsOptions.filter((options) => {
    return data.exclusions?.includes(options.value);
  });

  const cascading =
    cascadingOptions.find((option) => option.value === data.cascading) ||
    cascadingOptions[0];

  const initialValues = {
    name: data?.label || "",
    percentage: data?.percentage || "",
    rules,
    applicationLevel,
    taxType,
    cascading,
    exclusions,
  };

  return initialValues;
};
